import React, { useEffect, useMemo, useState } from 'react';
import { useStores } from '../../../store';
import { Address, AddressGroup, Rule } from '../../../../dtos/version.dto';
import { uniqBy } from 'lodash';
import { listCells } from '../inventory-utils';

interface AddressRuleCellProps {
    addressData?: Address;
    addressGroupData?: AddressGroup;
}

export const AddressRuleCell: React.FC<AddressRuleCellProps> = ({ addressData, addressGroupData }) => {
    const {fwVersionStore} = useStores();
    const [rules, setRules] = useState<Rule[]>([]);

    useEffect(() => {
        const addressGroups = retrieveAddressGroup();

        const addressGroupsIds = new Set(addressGroups.map(group => group.id));

        const srcRules = fwVersionStore.selectedVersionRules
            .filter(rule => rule.src.address.address_groups.some(group => addressGroupsIds.has(group)));

        const dstRules = fwVersionStore.selectedVersionRules
            .filter(rule => rule.dst.address.address_groups.some(group => addressGroupsIds.has(group)));

        setRules(uniqBy([...srcRules, ...dstRules], 'id'));
    }, [addressData, addressGroupData]);

    const retrieveAddressGroup = () => {
        if (addressGroupData) {
            return [addressGroupData];
        }
        return addressData ? fwVersionStore.selectedVersionAddressGroupsByAddress(addressData) : [];
    };

    return useMemo(() => listCells(rules, `address-rule`), [rules]);

};
